import React, {useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import '../styles.css';
import {cloneDeep} from 'lodash';
import {Checkbox} from '@components';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import ProcessExtractResultModal from '@pages/candidate/userinput/ProcessExtractResultModal';

const UploadCV = (props) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [processingCV, setProcessingCV] = useState(false);
    const [exportExcelFlg, setExportExcelFlg] = useState(false);
    const [cvFailedList, setCVFailedList] = useState([]);
    const [processRefCheckResult, setProcessRefCheckResult] = useState([]);

    const onSelectFiles = (event) => {
        setSelectedFiles(Array.from(event.target.files));
    };

    let {refererInfo, paramCandidateId, onFinishCheckExists} = props
    if (!refererInfo && props.location && props.location.search) {
        const refererInfoParams = new URLSearchParams(props.location.search).get("refererInfo")
        if (refererInfoParams) {
            refererInfo = JSON.parse(decodeURIComponent(refererInfoParams))
        }
    }

    if (!paramCandidateId && props.location && props.location.search) {
        paramCandidateId = new URLSearchParams(props.location.search).get("candidateId")
    }

    const extractCVFiles = async () => {
        console.log(`extractCVFiles - excel flag: ${exportExcelFlg}`);
        if (selectedFiles.length === 0) return;
        setCandidates([]);
        setProcessingCV(true);
        let count = 0;
        const canList = [];
        const faileds = [];
        setCVFailedList([]);
        selectedFiles.forEach((file, index) => {
            const data = new FormData();
            data.append('resume', file, file.name);
            CandidateService.requestUploadCV(data)
                .then((res) => {
                    console.log(JSON.stringify(res));
                    let newCan = res.content
                    if (newCan.email) {
                        newCan.require_email = true
                    }

                    if (newCan.phone) {
                        newCan.require_phone = true
                    }
                    if (paramCandidateId) {
                        newCan.id = paramCandidateId
                        newCan.candidate_id = paramCandidateId
                    }

                    canList.push(newCan);
                    setCandidates(cloneDeep(canList));

                    toast.success(`Xử lý CV thành công: ${file.name}`);
                })
                .catch((error) => {
                    // toast.error(`Xử lý CV bị lỗi: ${file.name}`);
                    console.log(`Error:${JSON.stringify(error)}`);
                    faileds.push(file.name);
                    setCVFailedList(cloneDeep(faileds));
                })
                .finally(() => {
                    count += 1;
                    if (count === selectedFiles.length) {
                        setProcessingCV(false);
                    }
                });
        });
    };

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title'>Extract CV</h3>
                </div>
                <div className='card-body'>
                    <form encType='multipart/form-data'>
                        <div className='form-group'>
                            <div className='custom-file'>
                                <input
                                    type='file'
                                    className='custom-file-input'
                                    id='customFile'
                                    name='files'
                                    multiple
                                    onChange={(event) => onSelectFiles(event)}
                                />
                                <label
                                    className='custom-file-label'
                                    htmlFor='customFile'
                                >
                                    {/* {selectedFiles[0]} */}
                                    {selectedFiles.map((item) => {
                                        return `${item.name}; `;
                                    })}
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
                <div className='card-footer'>
                    <div className='row'>
                        {/*<Checkbox*/}
                        {/*    checked={exportExcelFlg}*/}
                        {/*    onChange={(value) => {*/}
                        {/*        setExportExcelFlg(value);*/}
                        {/*    }}*/}
                        {/*    label={'Export excel file'}*/}
                        {/*/>*/}
                        <button
                            type='submit'
                            className='btn btn-primary'
                            onClick={() => extractCVFiles()}
                            disabled={processingCV}
                            data-toggle='modal' data-target='#inputCommonModal'
                        >
                            {processingCV ? 'Processing' : 'Upload CV'}
                        </button>
                    </div>
                </div>
            </div>
            {candidates && candidates.length > 0 &&
            <ProcessExtractResult
                isShow={processRefCheckResult.length === 0}
                candidateList={candidates}
                cvFailedList={cvFailedList}
                isExportExcel={exportExcelFlg}
                refererInfo={refererInfo}
                onFinishCheckExists={onFinishCheckExists}
                hasInputCommon={candidates.length > 1}
                onProcessRefCheckResult={(result) => setProcessRefCheckResult([result])}
            />
            }

            {processRefCheckResult.length > 0 &&
            <ProcessExtractResultModal extractResults={processRefCheckResult}
                                       isShow={processRefCheckResult.length > 0}
                                       onClose={() => setProcessRefCheckResult([])}/>
            }
        </div>
    );
};

export default UploadCV;
